import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, CanActivate, ActivatedRoute } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { ApiService } from './api.service';


@Injectable({ providedIn: 'root' })
export class AuthService implements CanActivate {
  flag;
  constructor(private router: Router,
    private apiService: ApiService,
    public oidcSecurityService: OidcSecurityService) {
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!this.oidcSecurityService.getToken()) {
      this.oidcSecurityService.authorize();
      // this.router.navigate(['']);
    }

    const currentPath = (route['_routerState'].url).split('/');
    if (this.apiService.userInfo) {
      if (this.apiService.userInfo.roles.some(role => role.name === 'Admin')) {
        if (currentPath[2] == 'index') {
          return true;
        }
      }
      if (this.apiService.routePath.includes(currentPath[2])) {
        return true;
      } else {
        this.router.navigate(['forbidden']);
        return false;
      }

    } else {
      this.apiService.getMenus().subscribe((response: any) => {
        this.apiService.userInfo = response.res;
        if (this.apiService.userInfo.profilePicture) {
          this.apiService.GetImage(this.apiService.userInfo.profilePicture).then(result => {
            this.apiService.userInfo.base64 = result.res.extention + result.res.imageString;
          })
        }
        for (let item of response.res.userMenu) {
          this.apiService.routePath.push(item.key.toLowerCase());
        }
        this.apiService.routePath.push('profile');
        if (this.apiService.userInfo.roles.some(role => role.name === 'Admin')) {
          if (currentPath[2] == 'index') {
            this.router.navigate(['pages/index']);
            return true;
          }
        }
        if (this.apiService.routePath.includes(currentPath[2])) {
          let temp = currentPath[1];
          for (let i = 2; i < currentPath.length; i++) {
            if (currentPath[i]) {
              temp += '/' +currentPath[i]
            }
          }
          this.router.navigate([temp])
          return true;
        } else {
          this.router.navigate(['forbidden']);
          return false;
        }
      });
    }


  }
}

